import React from 'react';
import PropTypes from 'prop-types';
import QueuedSample from './QueuedSample';

function QueuedSamples(props) {
  return [
    props.sampleGroups.map(sampleGroup => (
      <QueuedSample
        key={sampleGroup.imr_id}
        runId={props.runId}
        sampleGroup={sampleGroup}/>
    )),
    <tr key={props.runId} style={{backgroundColor: 'grey'}}>
      <td colSpan={7} height="10"></td>
    </tr>
  ];
}

QueuedSamples.propTypes = {
  sampleGroups: PropTypes.array.isRequired,
  runId: PropTypes.string.isRequired
};

export default QueuedSamples;
